module.exports = __webpack_public_path__ + "img/11_Splenic-Flexure.1e261cf8.png";